import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.62498 4.45703L5.05206 3.86328L3.86456 5.05078L4.45831 7.6237L2.08331 9.20703V10.7904L4.45831 12.3737L3.86456 14.9466L5.05206 16.1341L7.62498 15.5404L9.20831 17.9154H10.7916L12.375 15.5404L14.9479 16.1341L16.1354 14.9466L15.5416 12.3737L17.9166 10.7904V9.20703L15.5416 7.6237L16.1354 5.05078L14.9479 3.86328L12.375 4.45703L10.7916 2.08203H9.20831L7.62498 4.45703Z",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 9.9987C12.5 11.3794 11.3807 12.4987 9.99998 12.4987C8.61927 12.4987 7.49998 11.3794 7.49998 9.9987C7.49998 8.61799 8.61927 7.4987 9.99998 7.4987C11.3807 7.4987 12.5 8.61799 12.5 9.9987Z",
      stroke: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }